"use client";

import { FC, useState } from "react";
import Image from "next/image";
import Link from "next/link";
import clsx from "clsx";
import { Drawer } from "@mantine/core";
import { Accordion } from "@mantine/core";

import icon from "@/utils/icon.helper";

import { ISetDrawer } from "./HeaderMainMenuDrawer";
import { IHeaderMenuItemstype } from "./DesktopHeader";

import MenuDownloadSection, {
  IMenuDownloadBook,
} from "@/sections/common/MenuDownloadSection";

// --------------------------------------------------------------------------------------

export type IHeaderSubMenuProps = {
  subMenuOpened: boolean;
  setSubMenu: ISetDrawer;
  setMainMenu: ISetDrawer;
  heading?: string;
  subMenuList?: IHeaderMenuItemstype[];
  downloadBook?: IMenuDownloadBook;
  className?: string;
};

const HeaderSubMenu: FC<IHeaderSubMenuProps> = (props) => {
  const {
    subMenuOpened,
    setSubMenu,
    setMainMenu,
    heading,
    subMenuList,
    downloadBook,
    className,
  } = props;

  const [activeValue, setActiveValue] = useState("");
  const [activeCategory, setActiveCategory] = useState("");

  // Condition for mega menu - if item.items -> mega menu accordion created
  // const itemsWithSubItems = subMenuList?.filter(
  //   (item) => item.items !== undefined && item.items.length > 0,
  // );

  const itemsWithoutSubItems = subMenuList?.filter(
    (item) =>
      item.heading === undefined &&
      (item.items === undefined || item.items.length === 0),
  );
  const itemsWithCategory = subMenuList?.filter((item) => item.heading);

  const categoryWithSubCategory = itemsWithCategory?.filter(
    (item) =>
      (item.subCategory && item.subCategory.length > 0) || item.downloadBook,
  );

  const categoryWithoutSubCategory = itemsWithCategory?.filter(
    (item) =>
      (!item.subCategory || item.subCategory.length === 0) &&
      !item.downloadBook,
  );

  return (
    <Drawer
      lockScroll={false}
      opened={subMenuOpened}
      onClose={setSubMenu.close}
      size="100%"
      position="right"
      className={className}
      zIndex={998}
      keepMounted={false}
      transitionProps={{ duration: 150, transition: "slide-left" }}
    >
      <div className="container flex flex-col py-8">
        <div
          className="flex h-full cursor-pointer items-center justify-start gap-4 font-bricolage-grotesque text-base font-normal text-black-900 focus:bg-gray-100"
          onClick={setSubMenu.close}
        >
          <Image
            src={icon("chevron_right")}
            alt="chevron_right"
            height={12}
            width={6}
            style={{
              height: "auto",
              width: "auto",
            }}
            className="h-fit w-fit rotate-180 cursor-pointer px-4"
          />
          <span className="cursor-pointer font-bricolage-grotesque text-base font-normal text-black-900">
            Back to main navigation
          </span>
        </div>

        <p className="mb-6 mt-8 font-bricolage-grotesque text-base font-normal text-primary-900">
          {heading}
        </p>

        {/* Subitems Accordion */}
        {/* {itemsWithSubItems && itemsWithSubItems.length > 0 && (
          <Accordion
            className="border-transparent"
            styles={{
              chevron: { marginLeft: "30px", marginRight: "30px" },
              control: { padding: 0 },
              content: { padding: 0, paddingBottom: "16px" },
              label: { padding: 0 },
            }}
            onChange={(value) => value !== null && setActiveValue(value)}
          >
            {itemsWithSubItems.map((item, idx) => (
              <Accordion.Item
                key={idx}
                value={item.label}
                className="border-transparent"
              >
                <Accordion.Control>
                  <Link
                    href={item.href}
                    className={clsx(
                      "flex w-full items-center px-2 py-2 text-sm font-normal text-black-950 md:py-4 md:text-base",
                      activeValue === item.label &&
                        "text-primary-800  underline",
                    )}
                    onClick={() => {
                      setSubMenu.close(), setMainMenu.close();
                    }}
                  >
                    {item.label}
                  </Link>
                </Accordion.Control>
                <Accordion.Panel
                  className={clsx(activeValue === item.label && "space-y-4")}
                  onClick={() => {
                    setSubMenu.close(), setMainMenu.close();
                  }}
                >
                  {item.items?.slice(0, 5).map((itm, id) => (
                    <Link
                      key={id}
                      href={itm.href}
                      className="mb-1 flex w-full items-center px-2 py-2 text-sm font-normal text-gray-600 hover:text-secondary-900 focus:bg-gray-100 md:text-base"
                    >
                      {itm.label}
                    </Link>
                  ))}

                  {item.items && item.items.length > 5 && (
                    <Link
                      href={item.href}
                      className="mx-2 w-fit border-b-2 border-b-transparent  text-sm font-normal text-primary-700 hover:border-gray-500  md:text-sm"
                    >
                      See all
                    </Link>
                  )}
                </Accordion.Panel>
              </Accordion.Item>
            ))}
          </Accordion>
        )} */}

        {/* Subitems list */}
        {itemsWithoutSubItems && itemsWithoutSubItems.length > 0 && (
          <ul className="flex h-full flex-col flex-wrap gap-y-4 font-bricolage-grotesque text-base">
            {itemsWithoutSubItems.map(
              (submenu, id) =>
                (submenu?.header === undefined || submenu?.header) && (
                  <li
                    key={id}
                    className="flex h-7 w-full items-center justify-start font-bricolage-grotesque text-base font-normal text-black-900"
                    onClick={() => {
                      setMainMenu.close();
                      setSubMenu.close();
                    }}
                  >
                    <Link
                      href={submenu.href ?? ""}
                      className="flex h-full w-full items-center px-3 font-bricolage-grotesque text-sm font-light text-black-900 focus:bg-gray-100"
                    >
                      {submenu.label}
                    </Link>
                  </li>
                ),
            )}
          </ul>
        )}

        {/* Items with category: Services */}
        {categoryWithSubCategory && categoryWithSubCategory.length > 0 && (
          <Accordion
            styles={{
              chevron: { marginLeft: "30px", marginRight: "30px" },
              control: { padding: 0 },
              content: { padding: 0, paddingBottom: 0 },
              label: { padding: 0 },
            }}
            onChange={(value) => value !== null && setActiveCategory(value)}
          >
            {categoryWithSubCategory.map((item, index) => (
              <Accordion.Item
                key={index}
                value={item.heading ?? ""}
                className={clsx(
                  "border-transparent",
                  item.heading === activeCategory && "bg-gray-100",
                )}
              >
                <Accordion.Control
                  className={clsx(
                    item.heading === activeCategory && "bg-gray-200",
                  )}
                >
                  <Link
                    className={clsx(
                      "flex w-fit items-center px-3 py-3 font-bricolage-grotesque text-sm font-normal text-black-950 hover:text-secondary-900 md:py-4 md:text-base",
                    )}
                    href={item.categoryLink ?? ""}
                    onClick={() => {
                      setSubMenu.close();
                      setMainMenu.close();
                    }}
                  >
                    {item.heading}
                  </Link>
                </Accordion.Control>
                <Accordion.Panel>
                  {item.subCategory &&
                    (item.subCategory.length > 1 ? (
                      <Accordion
                        className="border-transparent"
                        styles={{
                          chevron: { marginLeft: "30px", marginRight: "30px" },
                          control: { padding: 0 },
                          content: { padding: 0, paddingBottom: "16px" },
                          label: { padding: 0 },
                        }}
                        onChange={(value) =>
                          value !== null && setActiveValue(value)
                        }
                      >
                        {item.subCategory.map((itm, idx) => (
                          <Accordion.Item
                            key={idx}
                            value={itm.heading}
                            className={clsx(
                              "border-transparent",
                              itm.heading === activeValue && "bg-gray-50",
                            )}
                          >
                            <Accordion.Control>
                              <span
                                className={clsx(
                                  "flex w-full items-center px-3 py-3 font-bricolage-grotesque text-sm font-normal text-black-950 md:py-4 md:text-base",
                                )}
                              >
                                {itm.heading}
                              </span>
                            </Accordion.Control>
                            <Accordion.Panel>
                              {itm.items.map((it, id) => (
                                <Link
                                  key={id}
                                  href={it.href}
                                  className="mb-2 flex w-full items-center px-3 py-3 font-bricolage-grotesque text-sm font-light text-gray-600 hover:text-secondary-900 focus:bg-gray-100"
                                  onClick={() => {
                                    setSubMenu.close();
                                    setMainMenu.close();
                                  }}
                                >
                                  {it.label}
                                </Link>
                              ))}
                            </Accordion.Panel>
                          </Accordion.Item>
                        ))}
                      </Accordion>
                    ) : (
                      <>
                        {item.subCategory[0]?.items.map((it, id) => (
                          <Link
                            key={id}
                            href={it.href}
                            className="mb-1 flex w-full items-center px-2 py-2 text-sm font-normal text-gray-600 hover:text-secondary-900 focus:bg-gray-100 md:text-base"
                            onClick={() => {
                              setSubMenu.close();
                              setMainMenu.close();
                            }}
                          >
                            {it.label}
                          </Link>
                        ))}
                      </>
                    ))}

                  {item.downloadBook && (
                    <MenuDownloadSection
                      heading={item.downloadBook.heading}
                      image={item.downloadBook.image}
                      button={item.downloadBook.button}
                      className="container my-5"
                    />
                  )}
                </Accordion.Panel>
              </Accordion.Item>
            ))}
          </Accordion>
        )}
        {categoryWithoutSubCategory?.map((item, idx) => (
          <Link
            key={idx}
            href={item.categoryLink ?? ""}
            className={clsx(
              "flex w-fit items-center px-3 py-3 font-bricolage-grotesque text-sm font-normal text-black-950 hover:text-secondary-900 md:py-4 md:text-base",
            )}
            onClick={() => {
              setSubMenu.close();
              setMainMenu.close();
            }}
          >
            {item.heading}
          </Link>
        ))}
      </div>

      {/* Download Now Section */}
      {downloadBook && (
        <MenuDownloadSection
          heading={downloadBook.heading}
          image={downloadBook.image}
          button={downloadBook.button}
          className="container mt-5 xl:mt-0"
        />
      )}
    </Drawer>
  );
};

export default HeaderSubMenu;
